var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _raf, _slideObserver, _resizeObserver, _ProductMiniSlideshow_instances, setupSlideshowSync_fn, syncToSlide_fn, _handleScroll, goTo_fn, update_fn, _slideshow, _exitTimer, _handleSlideSelect, _HeroProductGroups_instances, showSlide_fn;
import { Component } from "@theme/component";
class ProductMiniSlideshow extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductMiniSlideshow_instances);
    __publicField(this, "requiredRefs", ["carouselTrack"]);
    __privateAdd(this, _raf, 0);
    __privateAdd(this, _slideObserver, null);
    __privateAdd(this, _resizeObserver, null);
    __privateAdd(this, _handleScroll, () => {
      if (__privateGet(this, _raf)) return;
      __privateSet(this, _raf, requestAnimationFrame(() => {
        __privateSet(this, _raf, 0);
        __privateMethod(this, _ProductMiniSlideshow_instances, update_fn).call(this);
      }));
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const { carouselTrack } = this.refs;
    carouselTrack.addEventListener("scroll", __privateGet(this, _handleScroll), { passive: true });
    if (this.refs.carouselProgress && this.refs.carouselProgressFill) {
      __privateSet(this, _resizeObserver, new ResizeObserver(__privateGet(this, _handleScroll)));
      __privateGet(this, _resizeObserver).observe(carouselTrack);
    }
    __privateMethod(this, _ProductMiniSlideshow_instances, update_fn).call(this);
    if (this.hasAttribute("data-sync-with-slideshow")) {
      __privateMethod(this, _ProductMiniSlideshow_instances, setupSlideshowSync_fn).call(this);
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.carouselTrack?.removeEventListener("scroll", __privateGet(this, _handleScroll));
    if (__privateGet(this, _raf)) cancelAnimationFrame(__privateGet(this, _raf));
    __privateGet(this, _resizeObserver)?.disconnect();
    __privateSet(this, _resizeObserver, null);
    if (__privateGet(this, _slideObserver)) {
      __privateGet(this, _slideObserver).disconnect();
      __privateSet(this, _slideObserver, null);
    }
  }
}
_raf = new WeakMap();
_slideObserver = new WeakMap();
_resizeObserver = new WeakMap();
_ProductMiniSlideshow_instances = new WeakSet();
/**
 * Set up sync with main slideshow - watch for slide changes and scroll
 * the product carousel to show products from the active slide.
 */
setupSlideshowSync_fn = function() {
  const slideshowContainer = this.closest(".hero-with-products")?.querySelector("slideshow-slides");
  if (!slideshowContainer) return;
  const slides = slideshowContainer.querySelectorAll("slideshow-slide");
  if (!slides.length) return;
  __privateSet(this, _slideObserver, new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
        const slide = mutation.target;
        const isHidden = slide.getAttribute("aria-hidden") === "true";
        if (!isHidden) {
          const slideIndex = Array.from(slides).indexOf(slide);
          __privateMethod(this, _ProductMiniSlideshow_instances, syncToSlide_fn).call(this, slideIndex);
        }
      }
    });
  }));
  slides.forEach((slide) => {
    __privateGet(this, _slideObserver).observe(slide, {
      attributes: true,
      attributeFilter: ["aria-hidden"]
    });
  });
  const activeSlideIndex = Array.from(slides).findIndex(
    (slide) => slide.getAttribute("aria-hidden") === "false"
  );
  if (activeSlideIndex >= 0) {
    __privateMethod(this, _ProductMiniSlideshow_instances, syncToSlide_fn).call(this, activeSlideIndex);
  }
};
/**
 * Scroll the product carousel to show products from the given slide.
 * @param {number} slideIndex - The index of the active slide.
 */
syncToSlide_fn = function(slideIndex) {
  const { carouselTrack } = this.refs;
  const cards = Array.from(carouselTrack.children);
  const firstCardForSlide = cards.find(
    (card) => card.getAttribute("data-slide-index") === String(slideIndex)
  );
  if (firstCardForSlide instanceof HTMLElement) {
    const cardIndex = cards.indexOf(firstCardForSlide);
    __privateMethod(this, _ProductMiniSlideshow_instances, goTo_fn).call(this, cardIndex);
  }
};
_handleScroll = new WeakMap();
/**
 * Scroll the track so the card at the given index is aligned to the start.
 * @param {number} index
 */
goTo_fn = function(index) {
  const { carouselTrack } = this.refs;
  const card = carouselTrack.children[index];
  if (!(card instanceof HTMLElement)) return;
  const left = card.getBoundingClientRect().left - carouselTrack.getBoundingClientRect().left + carouselTrack.scrollLeft;
  carouselTrack.scrollTo({ left, behavior: "smooth" });
};
/**
 * Size and position the progress fill from the track's scroll position -
 * same scrollbar-thumb math as slideshow-progress.js (fill width matches
 * the visible proportion of the track, position matches scroll progress).
 */
update_fn = function() {
  const { carouselTrack, carouselProgress, carouselProgressFill } = this.refs;
  if (!carouselProgress || !carouselProgressFill) return;
  const barWidth = carouselProgress.clientWidth;
  const trackWidth = carouselTrack.clientWidth;
  const scrollWidth = carouselTrack.scrollWidth;
  const max = scrollWidth - trackWidth;
  const progress = Math.min(1, Math.max(0, max > 0 ? carouselTrack.scrollLeft / max : 0));
  const fillWidth = scrollWidth > 0 ? Math.max(24, trackWidth / scrollWidth * barWidth) : barWidth;
  const travel = Math.max(0, barWidth - fillWidth);
  carouselProgressFill.style.width = `${fillWidth}px`;
  carouselProgressFill.style.transform = `translateX(${progress * travel}px)`;
};
const HERO_CARD_EXIT_MS = 540;
class HeroProductGroups extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _HeroProductGroups_instances);
    __privateAdd(this, _slideshow, null);
    __privateAdd(this, _exitTimer, null);
    /**
     * Handle a deliberate slideshow selection, rather than transient slide
     * visibility changes while the scroll animation is in progress.
     * @param {CustomEvent} event
     */
    __privateAdd(this, _handleSlideSelect, (event) => {
      const slide = event.detail?.slide;
      const slides = __privateGet(this, _slideshow)?.querySelectorAll("slideshow-slide");
      if (!slide || !slides) return;
      __privateMethod(this, _HeroProductGroups_instances, showSlide_fn).call(this, Array.from(slides).indexOf(slide));
    });
  }
  connectedCallback() {
    const hero = this.closest(".hero-with-products");
    __privateSet(this, _slideshow, hero?.querySelector("slideshow-component"));
    const slides = __privateGet(this, _slideshow)?.querySelectorAll("slideshow-slide");
    if (!__privateGet(this, _slideshow) || !slides?.length) return;
    __privateGet(this, _slideshow).addEventListener("slideshow:select", __privateGet(this, _handleSlideSelect));
    const initialSlideIndex = Array.from(slides).findIndex(
      (slide) => slide.getAttribute("aria-hidden") === "false"
    );
    if (initialSlideIndex >= 0) {
      __privateMethod(this, _HeroProductGroups_instances, showSlide_fn).call(this, initialSlideIndex, true);
    }
  }
  disconnectedCallback() {
    __privateGet(this, _slideshow)?.removeEventListener("slideshow:select", __privateGet(this, _handleSlideSelect));
    __privateSet(this, _slideshow, null);
    if (__privateGet(this, _exitTimer)) {
      clearTimeout(__privateGet(this, _exitTimer));
      __privateSet(this, _exitTimer, null);
    }
  }
}
_slideshow = new WeakMap();
_exitTimer = new WeakMap();
_handleSlideSelect = new WeakMap();
_HeroProductGroups_instances = new WeakSet();
/**
 * Restart the selected slide's image pan and transition its product group.
 * @param {number} slideIndex
 * @param {boolean} [initial=false]
 */
showSlide_fn = function(slideIndex, initial = false) {
  const slides = __privateGet(this, _slideshow)?.querySelectorAll("slideshow-slide");
  const activeSlide = slides?.[slideIndex];
  if (!activeSlide) return;
  slides.forEach((slide) => slide.classList.remove("is-ken-burns"));
  void activeSlide.offsetWidth;
  activeSlide.classList.add("is-ken-burns");
  const groups = Array.from(this.querySelectorAll(".hero-with-products__products-group"));
  const activeGroup = groups.find((group) => group.dataset.slideIndex === String(slideIndex));
  const previousGroup = groups.find((group) => group.classList.contains("is-active"));
  if (__privateGet(this, _exitTimer)) {
    clearTimeout(__privateGet(this, _exitTimer));
    __privateSet(this, _exitTimer, null);
  }
  if (previousGroup && previousGroup !== activeGroup) {
    groups.forEach((group) => {
      if (group !== previousGroup) group.classList.remove("is-exiting");
    });
    previousGroup.classList.remove("is-active", "is-entering");
    previousGroup.classList.add("is-exiting");
    previousGroup.removeAttribute("data-hero-initial");
  }
  if (!activeGroup || activeGroup === previousGroup) return;
  activeGroup.removeAttribute("data-hero-initial");
  activeGroup.classList.remove("is-exiting");
  activeGroup.classList.add("is-entering");
  void activeGroup.offsetWidth;
  activeGroup.classList.remove("is-entering");
  activeGroup.classList.add("is-active");
  if (!initial && previousGroup) {
    __privateSet(this, _exitTimer, window.setTimeout(() => {
      previousGroup.classList.remove("is-exiting");
      __privateSet(this, _exitTimer, null);
    }, HERO_CARD_EXIT_MS));
  }
};
if (!customElements.get("product-mini-slideshow")) {
  customElements.define("product-mini-slideshow", ProductMiniSlideshow);
}
if (!customElements.get("hero-product-groups")) {
  customElements.define("hero-product-groups", HeroProductGroups);
}
